import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useLazyQuery } from '@vue/apollo-composable';

interface IProps {
  query: any;
  itemText?: string;
  paramsText?: string[];
  itemValue?: string;
  itemsInitialized?: any;
  noData?: string;
  placeholder?: string;
  attach?: string | null;
  value: any;
  multiple?: boolean;
}

interface IEmits {
  (event: 'input', e: any): void;
  (event: 'error', e: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AutocompleteGraphql',
  props: {
    query: null,
    itemText: { default: 'text' },
    paramsText: { default: () => [] },
    itemValue: { default: 'value' },
    itemsInitialized: { default: null },
    noData: { default: '' },
    placeholder: { default: 'Selecione' },
    attach: { default: undefined },
    value: null,
    multiple: { type: Boolean, default: true }
  },
  emits: ["input", "error"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'input', e: any): void;
  (event: 'error', e: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { query: any, itemText: string, paramsText: string[], itemValue: string, itemsInitialized: any, noData: string, placeholder: string, attach: string | null, value: any, multiple: boolean };

/* eslint-disable @typescript-eslint/no-explicit-any */




const minimumInput = 3;
const model = ref(props.value);
const search = ref('');
const items = ref(
  props.itemsInitialized ? props.itemsInitialized : props.value
);

const params = computed(() => {
  const value = props.itemText
    ? { [props.itemText]: search.value }
    : { value: search.value };
  return value;
});

const formatedItems = computed(() => {
  return items.value?.map((item: any) => {
    const formatedText = props.paramsText?.reduce((acc, curr, key) => {
      acc += (key ? ' - ' : '') + item[curr];
      return acc;
    }, '');
    return {
      ...item,
      formatedText: !props.paramsText?.length
        ? item[props.itemText]
        : formatedText,
    };
  });
});

const formatedText = computed(() => {
  return !props.paramsText?.length ? props.itemText : 'formatedText';
});

const { load, result, variables, error, loading, onResult } = useLazyQuery(
  props.query
);

onResult((queryResult) => {
  if (!queryResult.data?.[props.itemValue]) return;
  items.value = queryResult.data?.[props.itemValue];
});

watch(model, (newValue: string, oldValue: string) => {
  if (newValue !== oldValue) {
    emits('input', model.value);
  }
});

watch(search, async () => {
  resetItems();
  await fetchItems();
});

watch(
  () => props.value,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      model.value = newValue;
      items.value = props.itemsInitialized ? props.itemsInitialized : newValue;
    }
  },
  { deep: true }
);

const fetchItems = async () => {
  if (!search.value || search.value.length < minimumInput) return;

  if (loading.value) {
    stop();
  }

  variables.value = params.value;

  try {
    await load();
    if (props.itemValue) {
      items.value = result.value?.[props.itemValue] ?? [];
      return;
    }
    items.value = result.value ?? [];
  } catch {
    emits('error', error.value);
  }
};

const resetItems = () => {
  items.value = props.itemsInitialized ? props.itemsInitialized : props.value;
};

const resetSearch = () => {
  search.value = '';
};

return { __sfc: true,props, emits, minimumInput, model, search, items, params, formatedItems, formatedText, load, result, variables, error, loading, onResult, fetchItems, resetItems, resetSearch }
}

})